import { render, staticRenderFns } from "./video-list.vue?vue&type=template&id=5e18d126&scoped=true"
import script from "./video-list.vue?vue&type=script&lang=js"
export * from "./video-list.vue?vue&type=script&lang=js"
import style0 from "./video-list.vue?vue&type=style&index=0&id=5e18d126&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e18d126",
  null
  
)

export default component.exports